import mirror from 'keymirror';
import Pages from '../lib/pages';

export const actionTypes = mirror({
  PAGES_GET_BY_SLUG_ERROR: null,
  PAGES_GET_BY_SLUG_IN_PROGRESS: null,
  PAGES_GET_BY_SLUG_SUCCESS: null,
});

const pagesGetBySlugError = error => ({
  error,
  type: actionTypes.PAGES_GET_BY_SLUG_ERROR,
});

const pagesGetBySlugInProgress = () => ({
  type: actionTypes.PAGES_GET_BY_SLUG_IN_PROGRESS,
});

const pagesGetBySlugSuccess = results => ({
  results,
  type: actionTypes.PAGES_GET_BY_SLUG_SUCCESS,
});

export const getPagesBySlug = slug => async dispatch => {
  dispatch(pagesGetBySlugInProgress());
  try {
    const pages = await Pages.getPagesBySlug(slug);
    dispatch(pagesGetBySlugSuccess(pages));
  } catch (error) {
    dispatch(pagesGetBySlugError(error));
  }
};
